/* tslint:disable */
/* eslint-disable */
export enum Gender {
  Unspecified = 'Unspecified',
  Male = 'Male',
  Female = 'Female',
  Other = 'Other'
}
